import { useQuery } from '@tanstack/react-query'

import config from '@config'
import { getUserType } from '@utils/chatbot'
import { TQuestionResponse } from '@utils/chatbot/types'
import useUser from '@hooks/useUser'

const {
  aiSearch: { questionsUrl },
} = config

export const getQuestions = async ({ userType }: { userType: string }) => {
  const url = new URL(questionsUrl)

  url.searchParams.append('publication', 'blick')
  url.searchParams.append('widgetId', 'questionWidget')
  url.searchParams.append('context', 'home')

  if (userType) {
    url.searchParams.append('userType', userType)
  }

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error('Error fetching questions.')
  }

  return (await response.json()) as Promise<TQuestionResponse>
}

const useAISearchQuestions = () => {
  const user = useUser()
  const userType = getUserType(user?.email)

  const { data, error, isLoading, refetch } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['aiSearchQuestions'],
    queryFn: () => getQuestions({ userType }),
  })

  return {
    data,
    error,
    isLoading,
    refetch,
  }
}

export default useAISearchQuestions
